export default [
  { value: 'Pacific/Midway', label: '(UTC-11:00) Îles Midway' },
  { value: 'Pacific/Honolulu', label: '(UTC-10:00) Hawaï' },
  { value: 'America/Anchorage', label: '(UTC-09:00) Alaska' },
  { value: 'America/Los_Angeles', label: '(UTC-08:00) Los Angeles' },
  { value: 'America/Denver', label: '(UTC-07:00) Denver' },
  { value: 'America/Chicago', label: '(UTC-06:00) Chicago' },
  { value: 'America/New_York', label: '(UTC-05:00) New York' },
  { value: 'America/Caracas', label: '(UTC-04:30) Caracas' },
  { value: 'America/Halifax', label: '(UTC-04:00) Halifax' },
  { value: 'America/St_Johns', label: '(UTC-03:30) Terre-Neuve' },
  { value: 'America/Sao_Paulo', label: '(UTC-03:00) São Paulo' },
  { value: 'America/Argentina/Buenos_Aires', label: '(UTC-03:00) Buenos Aires' },
  { value: 'Atlantic/South_Georgia', label: '(UTC-02:00) Géorgie du Sud' },
  { value: 'Atlantic/Azores', label: '(UTC-01:00) Açores' },
  { value: 'UTC', label: '(UTC+00:00) UTC' },
  { value: 'Europe/London', label: '(UTC+00:00) Londres' },
  { value: 'Europe/Paris', label: '(UTC+01:00) Paris' },
  { value: 'Europe/Brussels', label: '(UTC+01:00) Bruxelles' },
  { value: 'Europe/Berlin', label: '(UTC+01:00) Berlin' },
  { value: 'Europe/Madrid', label: '(UTC+01:00) Madrid' },
  { value: 'Europe/Rome', label: '(UTC+01:00) Rome' },
  { value: 'Europe/Zurich', label: '(UTC+01:00) Zurich' },
  { value: 'Africa/Casablanca', label: '(UTC+01:00) Casablanca' },
  { value: 'Africa/Lagos', label: '(UTC+01:00) Lagos' },
  { value: 'Europe/Athens', label: '(UTC+02:00) Athènes' },
  { value: 'Europe/Bucharest', label: '(UTC+02:00) Bucarest' },
  { value: 'Africa/Cairo', label: '(UTC+02:00) Le Caire' },
  { value: 'Africa/Johannesburg', label: '(UTC+02:00) Johannesburg' },
  { value: 'Europe/Istanbul', label: '(UTC+03:00) Istanbul' },
  { value: 'Europe/Moscow', label: '(UTC+03:00) Moscou' },
  { value: 'Asia/Riyadh', label: '(UTC+03:00) Riyad' },
  { value: 'Asia/Dubai', label: '(UTC+04:00) Dubaï' },
  { value: 'Indian/Mauritius', label: '(UTC+04:00) Maurice' },
  { value: 'Indian/Maldives', label: '(UTC+05:00) Maldives' },
  { value: 'Asia/Kolkata', label: '(UTC+05:30) Inde' },
  { value: 'Asia/Dhaka', label: '(UTC+06:00) Dacca' },
  { value: 'Asia/Bangkok', label: '(UTC+07:00) Bangkok' },
  { value: 'Asia/Hong_Kong', label: '(UTC+08:00) Hong Kong' },
  { value: 'Asia/Singapore', label: '(UTC+08:00) Singapour' },
  { value: 'Asia/Tokyo', label: '(UTC+09:00) Tokyo' },
  { value: 'Australia/Sydney', label: '(UTC+10:00) Sydney' },
  { value: 'Pacific/Noumea', label: '(UTC+11:00) Nouméa' },
  { value: 'Pacific/Auckland', label: '(UTC+12:00) Auckland' },
];
